module.exports = __webpack_public_path__ + "static/angies-list-f0ec03baaf9c730a931209076f55c7a4.png";